import { render, staticRenderFns } from "./indexTitleSetting.vue?vue&type=template&id=05369dca&scoped=true&"
import script from "./indexTitleSetting.vue?vue&type=script&lang=js&"
export * from "./indexTitleSetting.vue?vue&type=script&lang=js&"
import style0 from "./indexTitleSetting.vue?vue&type=style&index=0&id=05369dca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05369dca",
  null
  
)

export default component.exports